

export default disallowIllegalReassignment;
import hasOwnProp from 'utils/hasOwnProp';

var bindingMessage = 'Cannot reassign imported binding ',
    namespaceMessage = 'Cannot reassign imported binding of namespace ';
function disallowIllegalReassignment(node, importedBindings, importedNamespaces, scope) {
	var assignee = undefined,
	    isNamespaceAssignment = undefined;

	if (node.type === 'AssignmentExpression') {
		assignee = node.left;
	} else if (node.type === 'UpdateExpression') {
		assignee = node.argument;
	} else {
		return; // not an assignment
	}

	if (assignee.type === 'MemberExpression') {
		assignee = assignee.object;
		isNamespaceAssignment = true;
	}

	if (assignee.type !== 'Identifier') {
		return; // not assigning to a binding
	}

	var name = assignee.name;

	if (hasOwnProp.call(isNamespaceAssignment ? importedNamespaces : importedBindings, name) && !scope.contains(name)) {
		throw new Error((isNamespaceAssignment ? namespaceMessage : bindingMessage) + '`' + name + '`');
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/ast/disallowIllegalReassignment.js.01-babel.map